<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3 mb-3">Committed Product</h3>

      <div class="search_bar mb-1">
        <b-card>
          <b-row class="mb-1">
            <b-col cols="2" class="pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.channel_selected"
                :options="channel_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.client_selected"
                :options="client_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.stock_status_selected"
                :options="stock_status_options"
              />
            </b-col>
            <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.fulfilment_status_selected"
                :options="fulfilment_status_options"
              />
            </b-col>
            <!-- <b-col cols="2" class="pl-0 pr-1">
              <b-form-select
                size="sm"
                v-model="search_criteria.tracking_status_selected"
                :options="tracking_status_options"
              />
            </b-col> -->
          </b-row>
          <b-row>
            <b-col cols="4" class="pl pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Product SKU"
                v-model="search_criteria.product_sku"
               @keyup.enter="onSearch"></b-form-input>
            </b-col>
            <b-col cols="4" class="pl-0 pr-1">
              <b-form-input
                id="input-small"
                size="sm"
                type="text"
                placeholder="Order Number"
                v-model="search_criteria.order_number"
               @keyup.enter="onSearch"></b-form-input>
            </b-col>
            
            <b-col class="text-left p-0">
              <b-button
                v-if="checkPermission($store.state.user_obj, 'Order Management', 'Committed Product', 'Search', true)"
                class="btn-action"
                size="sm"
                variant="info"
                @click="onSearch"
              >
                <font-awesome-icon class="mr-1" icon="search" />Search
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </div>

      <strong># of Records: {{ total_rows }}</strong>

      <b-row class="mb-1">
        <b-col cols="1" class="pr-0">
          <b-form-select
            size="sm"
            v-model="sel_table_limit"
            :options="[50, 100, 200, 500]"
            @change="getCommittedProducts()"
          />
        </b-col>
        <b-col class="pl-0 pr-1">
          <b-pagination
            size="sm"
            :total-rows="total_rows"
            v-model="currentPage"
            :per-page="sel_table_limit"
            @change="onPageChange"
            :limit="PAGING_LIMIT"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        :items="items"
        :fields="fields"
        :tbody-tr-class="rowClass"
      >
        <template v-slot:head(chk_box)="data">
          <b-form-checkbox
            size="sm"
            plain
            id="chkbox_all"
            value="all"
            v-model="check_all_rows"
          ></b-form-checkbox>
        </template>
        <template v-slot:cell(chk_box)="data">
          <b-form-checkbox
            size="sm"
            class="chkbox_row"
            plain
            :id="'chkbox_row_' + data.index"
            v-model="data.item.is_checked"
          ></b-form-checkbox>
        </template>

        <template v-slot:cell(order_date)="data">
          {{ displayDate(data.item.order_date) }}
        </template>

        <template v-slot:cell(no_of_order)="data">
          <router-link
            :to="{
              name: 'back_order_detail',
              params: {
                product_id: data.item.product_id,
                bo_status: data.item.bo_status
              }
            }"
          >
            {{ data.item.orders.length }}
          </router-link>
        </template>

        <!-- <template v-slot:cell(payment_status)="data">
          -
        </template> -->

        <template v-slot:cell(order_import_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_import_status }}</span>

            <span
              v-if="data.item.order_import_status == 'cancel'"
              class="dot_red"
            ></span>
            <span
              v-if="data.item.order_import_status == 'hold'"
              class="dot_red"
            ></span>
            <span
              v-if="data.item.order_import_status == 'pending'"
              class="dot_yellow"
            ></span>
            <span
              v-if="data.item.order_import_status == 'received'"
              class="dot_green"
            ></span>
          </div>
        </template>

        <template v-slot:cell(order_stock_status)="data">
          <div>
            <span class="span-status">{{ data.item.order_stock_status }}</span>

            <span v-if="data.item.order_stock_status == '-'" class="dot_white"></span>
            <span v-if="data.item.order_stock_status == 'pending'" class="dot_red"></span>
            <span
              v-if="data.item.order_stock_status == 'available'"
              class="dot_yellow"
            ></span>
            <span
              v-if="data.item.order_stock_status == 'committed'"
              class="dot_green"
            ></span>
          </div>
        </template>

        <template v-slot:cell(fulfilment_status)="data">
          <div>
            <span class="span-status">{{ data.item.fulfilment_status }}</span>

            <span
              v-if="data.item.fulfilment_status == '-'"
              class="dot_white"
            ></span>
            <span
              v-if="data.item.fulfilment_status == 'pending'"
              class="dot_yellow"
            ></span>
            <span
              v-if="data.item.fulfilment_status == 'completed'"
              class="dot_green"
            ></span>
            <span
              v-if="data.item.fulfilment_status == 'fulfiled'"
              class="dot_green"
            ></span>
          </div>
        </template>

        <!-- <template v-slot:cell(delivery_status)="data">
          <div>
            
            <span v-if="data.item.delivery_status == '-'" class="dot_white"></span>
            <span v-if="data.item.delivery_status == 'pending'" class="dot_yellow"></span>
            <span v-if="data.item.delivery_status == 'completed'" class="dot_green"></span>
            <span v-if="data.item.delivery_status == 'fulfiled'" class="dot_green"></span>

          </div>
        </template> -->

        <template v-slot:cell(action)="data">
          <b-button
            v-if="checkPermission($store.state.user_obj, 'Order Management', 'Committed Product', 'Rollback Order', true)"
            class="btn-action"
            size="sm"
            variant="info"
            @click="rollbackItem(data.item)"
            >Rollback</b-button
          >
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="sel_table_limit"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";

const fields = [
  {
    key: "upload_date",
    label: "Upload Date"
  },
  {
    key: "order_date",
    label: "Order Date"
  },
  {
    key: "product_sku",
    label: "Product SKU"
  },
  {
    key: "product_channel_sku",
    label: "Other SKU"
  },
  {
    key: "committed_qty",
    label: "Quantity",
    class: "center_align"
  },
  {
    key: "order_number",
    label: "Order Number"
  },
  {
    key: "order_stock_status",
    label: "Order Stock Status",
    class: "txt_camelcase center_align container-status"
  },
  {
    key: "fulfilment_status",
    label: "Fulfilment Status",
    class: "txt_camelcase center_align container-status"
  },
  // {
  //   key: "tracking_status",
  //   label: "Tracking Status",
  //   class: "txt_camelcase center_align container-status"
  // },
];

import global_function from "../mixins/global_function";

export default {
  name: "OrderMaster",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  mixins: [apiService, global_function],
  components: {
    barcode: VueBarcode
  },
  data() {
    return {
      sel_table_limit: this.TABLE_LIMIT,
      courier_options: [],
      export_date: {
        start_at: moment()
          .subtract(7, "d")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD")
      },
      upload_file: [],
      loader_full: false,
      loader: false,
      items: [],
      fields: fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      updating_item: false,
      export_criteria: {
        courier_selected: null,
        channel_selected: null
      },
      search_criteria: {
        keyword: "",
        product_sku: "",
        order_number: "",
        channel_selected: null,
        client_selected: null,
        start_at: moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD"),
        end_at: moment().format("YYYY-MM-DD"),
        order_status_selected: null,
        stock_status_selected: "pending",
        fulfilment_status_selected: "-",
        tracking_status_selected: "processed"
      },
      showAlert_success: false,
      alert_success_message: "",

      showAlert_error: false,
      alert_error_message: "",

      channel_options: [
        {
          value: null,
          text: "All Channel"
        }
      ],

      client_options: [
        {
          value: null,
          text: "All Client"
        }
      ],

      order_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        },
      ],
      stock_status_options: [
        {
          value: null,
          text: "All Stock Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "available",
          text: "Available"
        },
        {
          value: "committed",
          text: "Committed"
        }
      ],

      fulfilment_status_options: [
        {
          value: null,
          text: "All Fulfilment Status"
        },
        {
          value: "-",
          text: "-"
        },
        {
          value: "fulfiled",
          text: "Fulfilled"
        },
        {
          value: "pending",
          text: "Pending"
        }
      ],

      tracking_status_options: [
        {
          value: null,
          text: "All Tracking Status"
        },
        {
          value: "Non-successful",
          text: "Non-successful"
        },
        {
          value: "processed",
          text: "Processed"
        },
        {
          value: "ready_for_shipment",
          text: "ready_for_shipment"
        },
        {
          value: "ready_for_fulfilment",
          text: "ready_for_fulfilment"
        },
        {
          value: "pending",
          text: "Pending"
        },
        {
          value: "in_transit",
          text: "In-Transit"
        },
        {
          value: "successful",
          text: "Successful Delivery"
        },
        {
          value: "shipped_at",
          text: "Shipped at"
        },
        {
          value: "returned_to_warehouse",
          text: "Returned to Warehouse"
        },
        {
          value: "return_to_warehouse",
          text: "Returning to Warehouse"
        },
        {
          value: "reschedule",
          text: "Reschedule"
        },
        {
          value: "unreach",
          text: "Unreach"
        },
        {
          value: "reject",
          text: "Reject"
        },
        {
          value: "delay",
          text: "Delay"
        },
        {
          value: "other",
          text: "Other"
        }
      ],

      check_all_rows: false,
      outstanding_order_cnts: {},
      outstanding_stock_cnts: {},
      outstanding_fulfilment_cnts: {},
      o_cnts: {},
      loader: {},
    };
  },
  async created() {
    if(this.$store.state.user_obj.account_type != 'client_user'){
      this.fields.push({
    key: "action",
    label: "Action",
  });
    }

    await this.getCommittedProducts();
    let channels_response = await this.getChannels(this.$store.state.user_obj);
    for (let i in channels_response.channels) {
      this.channel_options.push({
        value: channels_response.channels[i].name,
        text: channels_response.channels[i].name
      });
    }
    this.initialized = true;
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    // whenever changes, this function will run
    check_all_rows: function(new_val, old_val) {
      // this.check_all_rows = !this.check_all_rows;
      console.log("check_all_rows");
      if (new_val == "all") {
        // Check all
        for (let i in this.items) {
          this.items[i].is_checked = true;
        }
      } else {
        for (let i in this.items) {
          this.items[i].is_checked = false;
        }
      }
      console.log(this.items);
    }
  },
  methods: {
    exportCSV() {
      let export_url =
        process.env.VUE_APP_API_HOST + "/export_order_inventory.php?";
        this.search_criteria.client_id = this.$store.state.user_obj.client_id;
      for (let i in this.search_criteria) {
        if (this.search_criteria[i] != null) {
          export_url += `&${i}=` + this.search_criteria[i];
        }
      }
      // export_url += "&tracking_number=" + this.search_criteria.tracking_number;
      export_url = encodeURI(export_url);
      window.open(export_url, "_blank");
    },

    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async bulkDownloadWayBill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "hkt_bulk_waybill.php",
        data: {
          items: this.items
        }
      });
      if (response.data.url) {
        window.open(response.data.url, "_blank");
      }
      this.loader.hide();
    },

    async updateImportStatus(row_data, status) {
      if (status == "cancel") {
        return;
      }
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async rollbackItem(row_data) {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_product_committed_rollback.php",
        data: {
          order_master_id: row_data.order_id,
          order_product_id: row_data.order_product_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.loader.hide();
      this.getCommittedProducts();
    },

    async doCommitOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_commit.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Commit Order Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async doCancelOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_cancel.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async doHoldOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_hold.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Cancel Order Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async doFulfillOrder(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Fulfil Order Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async updateFulfillStatus(row_data) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          order_master_ids: [row_data.id],
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });

      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async onSearchByStatus(status_type, status_value) {
      this.search_criteria[status_type] = status_value;
      this.getCommittedProducts();
    },

    async getCommittedProducts() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_product_committed_get.php",
        data: {
          offset: this.table_offset,
          limit: this.sel_table_limit,
          search_criteria: this.search_criteria,
          client_id: this.$store.state.user_obj.client_id
        }
      });
      this.items = response.data.committed_products;
      this.total_rows = response.data.total_rows;
      // this.outstanding_order_cnts = response.data.outstanding_order_cnts;
      // this.outstanding_stock_cnts = response.data.outstanding_stock_cnts;
      // this.outstanding_fulfilment_cnts =
      //   response.data.outstanding_fulfilment_cnts;
      this.loader.hide();
    },

    onSearch() {
      for (const key in this.search_criteria) {
        if (typeof this.search_criteria[key] === "string") {
          this.search_criteria[key] = this.search_criteria[key].trim();
        }
      }
      this.getCommittedProducts();
    },

    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.sel_table_limit;
      this.getCommittedProducts();
    },

    downloadWaybill(data) {
      let url = process.env.WAYBILL_HOST + "/waybill?";
      url += "id=" + data.tracking_number;
      window.open(url, "_blank");
    },

    async onBulkAction(bulk_action) {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let o_products = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].bo_status == "no_bo_pending"
        ) {
          o_products.push(this.items[i]);
        }
      }

      // call action
      let action_urls = {
        create_bo: "back_order_generate.php"
      };

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: action_urls[bulk_action],
        data: {
          o_products: o_products,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Bulk Update Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async onBulkApprove() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_approval.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async onBulkFulfill() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });
      let order_master_ids = [];
      for (let i in this.items) {
        if (
          this.items[i].is_checked &&
          this.items[i].order_import_status != "pending" &&
          this.items[i].fulfilment_status == "pending"
        ) {
          order_master_ids.push(this.items[i].id);
        }
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfill.php",
        data: {
          status: status,
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id
        }
      });
      this.loader_full.hide();
      this.$eventHub.$emit("show_alert_message", {
        alert_message: "Update Success",
        variant: "success"
      });
      this.getCommittedProducts();
    },

    async pullShopifyOrders() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      this.$http({
        url:
          this.NODEJS_API_URL +
          "/shopify_order_get?client_id=" +
          this.$store.state.user_obj.client_id,
        method: "GET",
        data: null
      }).then(response => {
        this.loader_full.hide();
        this.getCommittedProducts();
        // let json_response = JSON.parse();
        this.$eventHub.$emit("show_modal_message", {
          message_content: `New Orders: ${response.data.cnt_new_order} \r\n Updated Orders: ${response.data.cnt_update_order}`
        });
      });
    },

    async onUploadFile() {
      this.loader_full = this.$loading.show({
        isFullPage: true,
        canCancel: false
      });

      let formData = new FormData();
      formData.append("excel_file", this.upload_file);
      formData.append("user_id", this.$store.state.user_obj.user_id);
      formData.append("client_id", this.$store.state.user_obj.client_id);

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_import.php",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData
      });

      if (response) {
        this.loader_full.hide();
        this.$eventHub.$emit("show_alert_message", {
          alert_message: "Upload Success",
          variant: "success"
        });
        if (response.data.auto_route_assigned_items) {
          this.$eventHub.$emit("show_auto_route_review", {
            items: response.data.auto_route_assigned_items
          });
        }
        this.getCommittedProducts();
      }
    },

    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.is_checked) return "table-info";
    }
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.span-status {
  display: none;
}

.container-status:hover .span-status {
  display: inline;
}

.row-status_cnt {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/CommittedProducts.vue